module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_spreadsheet_x32-bf6b2.png";